import { render, staticRenderFns } from "./SendMessageTemplateRegister.vue?vue&type=template&id=4854eeb8&scoped=true&lang=pug"
import script from "./SendMessageTemplateRegister.vue?vue&type=script&lang=ts"
export * from "./SendMessageTemplateRegister.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTemplateRegister.vue?vue&type=style&index=0&id=4854eeb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4854eeb8",
  null
  
)

export default component.exports